'use client';
import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import DynamicButton from '@components/DynamicButton';
import cn from './style.module.scss';

interface CommonDynamicButtonProps {
  label: string;
  scrollToId?: string;
  onClick?: () => void;
  icon?: ReactNode;
  className?: string;
  elementClassName?: string;
}

export default function CommonDynamicButton({
  label,
  scrollToId,
  onClick,
  icon,
  className,
  elementClassName,
}: CommonDynamicButtonProps) {
  return (
    <Box className={`${cn.commonDynamicButton} ${className}`}>
      <DynamicButton
        className={`${cn.commonDynamicElement} ${elementClassName}`}
        {...(scrollToId && { scrollToId })}
        {...(onClick && { onClick })}
      >
        {icon}
        {label}
      </DynamicButton>
    </Box>
  );
}
